.titleColumn {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.titleRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 12px;
}

.titleAndSwitch {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.875rem;
    font-weight: 500;
}

.titleAndSwitch :global(.MuiTypography-root) {
    font: inherit;
}

.actions {
    display: flex;
    justify-content: flex-end;
}

.inheritedParentLink {
    padding: 0;
    min-width: 0;
    vertical-align: baseline;
    font: inherit;
    text-transform: none;
    text-decoration: underline;
}

.addContactButton {
    margin-top: 8px;
    border-style: dashed;
    text-transform: none;
}

.contactRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.contactMain {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.contactInfo {
    display: flex;
    flex-direction: column;
    min-width: 0;
}
